define(["require", "exports", "tslib", "mobx", "../EntityBase", "./PermitLicItem"], function (require, exports, tslib_1, mobx_1, EntityBase_1, PermitLicItem_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitLicenseItemModel = void 0;
    class PermitLicenseItemModel {
        constructor(permit, itemDef, item = null, isApplicable = true, isActive = false, onSelectionChangeEventCallback) {
            Object.defineProperty(this, "p", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "itemDef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "item", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isApplicable", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "isActive", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "onSelectionChangeEventCallback", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsSelected", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            (0, mobx_1.makeObservable)(this);
            this.p = permit;
            this.itemDef = itemDef;
            this.item = item;
            this.isApplicable = isApplicable;
            this.isActive = isActive;
            this.onSelectionChangeEventCallback = onSelectionChangeEventCallback;
            this.updateSelectedStatus();
        }
        get LicenseDefinition() {
            return this.itemDef;
        }
        get Description() {
            return this.itemDef.Description;
        }
        set IsApplicable(value) {
            if (value) {
                this.isApplicable = true;
            }
            else {
                this.isApplicable = false;
                this.removeLicenseItem();
            }
        }
        get IsApplicable() {
            return this.isApplicable;
        }
        get IsActive() {
            return this.isActive;
        }
        toggleSelection() {
            this.IsSelected = !this.IsSelected;
            if (this.IsSelected) {
                this.addOrRestoreLicenseItem();
            }
            else {
                this.removeLicenseItem();
            }
        }
        addOrRestoreLicenseItem() {
            if (this.item == null) {
                this.item = new PermitLicItem_1.PermitLicItem(null, this.p);
                this.item.LicenseItemId = this.itemDef.Id;
                this.item.ItemType = this.itemDef.ItemType;
                this.p.PermitLicItem.push(this.item);
            }
            else {
                if (this.item.PersistanceState == EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                    this.item.PersistanceState = this.item.PersistanceStateBeforeDelete;
                }
                else {
                    throw new Error("Permit License this.item state should have been marked as deleted");
                }
            }
            this.onSelectionChangeEventCallback.call(this);
            this.updateSelectedStatus();
        }
        removeLicenseItem() {
            if (this.item != null) {
                if (this.item.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                    this.p.PermitLicItem = this.p.PermitLicItem.filter(x => {
                        return (x.Id != this.item.Id);
                    });
                    this.item = null;
                }
                else {
                    this.item.markForDeletion();
                }
            }
            this.onSelectionChangeEventCallback.call(this);
            this.updateSelectedStatus();
        }
        updateSelectedStatus() {
            this.IsSelected = this.item != null && this.item.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION;
        }
    }
    exports.PermitLicenseItemModel = PermitLicenseItemModel;
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicenseItemModel.prototype, "IsSelected", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseItemModel.prototype, "toggleSelection", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicenseItemModel.prototype, "updateSelectedStatus", null);
});
